module.exports = __webpack_public_path__ + "img/3fdd3c0a97689184ce4c7b6b36fc68dd.png";